import { MultiviewChannel, PlayerSlot, RecordedItem } from './ComplianceMonitoring.types';

export const multiviewChannels: MultiviewChannel[] =
  window.__APP_CONFIG__?.MULTIVIEW_CHANNELS?.filter(
    (channel): channel is MultiviewChannel =>
      typeof channel?.name === 'string' &&
      channel.name.trim().length > 0 &&
      typeof channel?.url === 'string' &&
      channel.url.trim().length > 0
  ) ?? [];

export const playerSlots: PlayerSlot[] = Array.from({ length: 12 }, (_, index) => ({
  id: `player-${index + 1}`,
  name: `Player ${index + 1}`,
}));

export const recordedItems: RecordedItem[] = [
  {
    id: 'rec-1',
    title: 'Morning News',
    streamUrl: '',
    duration: '00:42:10',
    size: '1.4 GB',
    date: '2025-12-12 08:00',
    description: 'Daily news .',
    keywords: ['news', 'weather', 'finance'],
  },
  {
    id: 'rec-2',
    title: 'Sports Recap',
    streamUrl: '',
    duration: '00:28:35',
    size: '950 MB',
    date: '2025-12-05 21:30',
    description: 'Weekend sports .',
    keywords: ['sports', 'recap'],
  },
  {
    id: 'rec-3',
    title: 'News Hour',
    streamUrl: '',
    duration: '01:12:05',
    size: '2.3 GB',
    date: '2025-12-05 18:15',
    description: 'In-depth news coverage.',
    keywords: ['documentary', 'urban', 'news'],
  },
];
